import React from 'react';

export default [
  {
    id: '1',
    image: {
      x: '-8.7331717',
      y: '-51.9742503',
      width: '276.102646',
      height: '418.238859',
    },
    gTransform: 'translate(390.98 .625)',
    pathDef:
      'M267.369474,116.464691 L189.692843,194.185148 C141.753691,144.389916 74.1575645,112.440201 0.109060226,110.401057 L0.109060226,0.380822104 C104.505056,2.42765359 199.545225,46.7591245 267.369474,116.464691 Z',
    caption: (
      <span>
        LIFE COMES
        <br />
        TOGETHER
      </span>
    ),
  },
  {
    id: '2',
    image: {
      x: '-21.9102498',
      y: '-18.6972334',
      width: '247.93883',
      height: '372.581116',
    },
    gTransform: 'translate(580.211 116.297)',
    pathDef:
      'M186.249238,267.782136 L76.3705388,267.782136 C76.3195582,194.475901 47.389782,127.438842 0.353551013,78.443021 L78.0605442,0.657297297 C144.97555,69.567189 186.197855,164.103037 186.249238,267.782136 Z',
    caption: (
      <span>
        Connected
        <br />
        Convenience
      </span>
    ),
  },
  {
    id: '3',
    image: {
      x: '-28.8494591',
      y: '-3.86082828',
      width: '395.810237',
      height: '263.597093',
    },
    gTransform: 'translate(580.211 383.353)',
    pathDef:
      'M78.0605442,267.250487 L0.353551013,189.464763 C47.389782,140.468942 76.3195582,73.9262847 76.3705343,0.620049879 L186.249241,0.620049878 C186.197855,104.299149 144.97555,198.340595 78.0605442,267.250487 Z',
    caption: (
      <span>
        Naturally
        <br />
        Authentic
      </span>
    ),
  },
  {
    id: '4',
    image: {
      x: '-23.466464',
      y: '-29.1157568',
      width: '300.873266',
      height: '227.464484',
    },
    gTransform: 'translate(390.98 572)',
    pathDef:
      'M0.0764797699,194.552399 L0.0764797699,84.5321641 C74.124984,82.49302 141.749147,50.567008 189.688299,0.771776357 L267.363794,78.5415116 C199.539545,148.247078 104.472476,192.505568 0.0764797699,194.552399 Z',
    caption: <span>LEGENDARY VIEWS</span>,
  },
  {
    id: '5',
    image: {
      x: '-9.29675915',
      y: '-154.986063',
      width: '293.860037',
      height: '444.684835',
    },
    gTransform: 'translate(116.439 579.763)',
    pathDef:
      'M78.2654805,0.391195089 C127.254903,47.5166306 194.252499,76.8739469 267.561087,76.8739469 C269.985107,76.8739469 272.401737,76.8422738 274.810586,76.7793184 L274.810563,186.796557 C272.399468,186.841424 269.982906,186.863957 267.561087,186.863957 C163.910286,186.863957 69.3390297,145.063846 0.455932332,78.0392504 L78.2654805,0.391195089 Z',
    caption: (
      <span>
        RICH HISTORY
        <br />
        VIBRANT Future
      </span>
    ),
  },
  {
    id: '6',
    image: {
      x: '-147.20575',
      y: '-16.3816734',
      width: '475.760394',
      height: '313.378774',
    },
    gTransform: 'translate(.884 383.353)',
    pathDef:
      'M116.284057,274.705143 C44.9978609,205.202301 0.709014261,108.088703 0.655753406,0.620049878 L110.534452,0.620049878 C110.588068,77.7157558 142.583355,147.330542 193.989538,196.920933 L116.284057,274.705143 Z',
    caption: (
      <span>
        Community
        <br />
        Experience
      </span>
    ),
  },
  {
    id: '7',
    image: {
      x: '-71.2907262',
      y: '-11.8468741',
      width: '466.400777',
      height: '311.165031',
    },
    gTransform: 'translate(.884 108.534)',
    pathDef:
      'M194.278674,78.3076285 C142.872491,127.898019 110.588068,198.423526 110.534457,275.519232 L0.655749951,275.519232 C0.709014261,168.050578 45.3919619,70.0092721 116.678158,0.506430851 L194.278674,78.3076285 Z',
    caption: (
      <span>
        Refreshingly
        <br />
        Innovative
      </span>
    ),
  },
  {
    id: '8',
    image: {
      x: '-35.8941507',
      y: '-33.2590645',
      width: '346.054431',
      height: '264.730978',
    },
    gTransform: 'translate(117.214 .625)',
    pathDef:
      'M0.231094565,108.604369 C69.1141919,41.5797726 163.134747,0.306013114 266.785548,0.306013114 C269.207367,0.306013114 271.623929,0.328545756 274.035035,0.373413035 L274.035023,110.390651 C271.626198,110.327696 269.209568,110.296023 266.785548,110.296023 C193.476959,110.296023 126.92751,139.264657 77.9380878,186.390092 L0.231094565,108.604369 Z',
    caption: (
      <span>
        Thoughtfully
        <br />
        Designed
      </span>
    ),
  },
];



// WEBPACK FOOTER //
// ./src/data/gallery.js